import cn from 'classnames';

/* Class assignment */
export const optionClass = (id: string, selectedOption: string | undefined) =>
  cn('flex items-center p-4 w-full rounded-md', {
    'bg-primary-500 cursor-default': selectedOption === id,
    'hover:bg-gray-700 cursor-pointer': selectedOption !== id,
  });
